<template>
    <div>
        <br>
        <nav class="navbar navbar-expand-lg navbar-light">
            <div class="ml-auto">
                <form v-on:keypress.enter.prevent="searchOrderList(1)" class="form-inline my-2 my-lg-0">
                    <input
                        class="form-control mr-sm-2"
                        type="search"
                        placeholder="ค้นหาเลขที่ใบจอง"
                        aria-label="Search"
                        v-model="search.order_id"/>
                    <date-picker v-model="search.date"
                                 range
                                 placeholder="วันที่เริ่มต้น - วันที่สิ้นสุด"
                                 :format="changeFormat"
                                 :lang="lang" confirm>
                    </date-picker>
                    &nbsp;
                    <b-form-select
                        v-model="search.status"
                        :options="status"></b-form-select>
                    &nbsp
                    <b-form-select
                        v-model="search.transport_type"
                        :options="transport"></b-form-select>
                    &nbsp
                    <multiselect
                        v-model="search.product"
                        class="form-control border-0"
                        :options="optionProducts"
                        :customLabel="LabelSkuWithName"
                        placeholder="ค้นหาสินค้า"
                        :show-labels="false"
                        track-by="id">
                    </multiselect>
                    <select class="form-control" v-model="search.product_type_id">
                        <option
                            v-for="options in optionProductType"
                            :value="options.value">{{ options.text }}
                        </option>
                    </select>
                    <template v-if="canViewAccounting">
                        <multiselect
                            v-model="search.sale"
                            class="form-control border-0"
                            :options="sellers"
                            :customLabel="customSaleNameWithCode"
                            placeholder="ค้นหาเซลล์"
                            :show-labels="false"
                            track-by="name">
                        </multiselect>
                    </template>
                    <multiselect
                        v-model="search.customer"
                        class="form-control border-0"
                        :options="customers"
                        :customLabel="customerWithLabel"
                        placeholder="ค้นหาลูกค้า"
                        :show-labels="false"
                        track-by="id">
                    </multiselect>
                    <button
                        class="btn btn-success my-2 my-sm-0"
                        type="button"
                        @click="searchOrderList(1)">
                        <icon name="search"></icon>
                        ค้นหา
                    </button>
                    &nbsp
                    <button @click="goToOrderForm(null)"
                            class="btn btn-warning my-2 my-sm-0"
                            type="button">
                        <icon name="plus"></icon>
                        สร้างใบจอง
                    </button>
                    &nbsp
                    <button @click="printMultipleOrder"
                            :disabled="checkbox_id.length < 1"
                            class="btn btn-primary my-2 my-sm-0"
                            type="button">
                        <icon name="print"></icon>
                        พิมพ์ใบจอง
                    </button>&nbsp;
                    <button @click="printOrderList"
                            class="btn btn-primary my-2 my-sm-0"
                            type="button">
                        <icon name="print"></icon>
                        พิมพ์รายงานค้างส่งใบจอง
                    </button> &nbsp;
                    <button class="btn btn-info my-2 my-sm-0"
                            @click="changeOrderStatus(3)"
                            :disabled="checkbox_id.length < 1"
                            type="button"
                            v-if="canViewAccounting">
                        <icon name="ban"></icon>
                        ปิดใบจอง
                    </button>
                    &nbsp;
                    <button class="btn btn-info my-2 my-sm-0"
                            v-if="canViewSuperAdmin"
                            @click="showChangeOrderStatus"
                            :disabled="checkbox_id.length < 1"
                            type="button">
                        <icon name="pencil-alt"></icon>
                        เปลี่ยนสถานะใบจอง
                    </button>
                </form>
            </div>
        </nav>
        <!-- table -->
        <div class="col-sm-12 table-responsive">
            <table class="table table-bordered text-center">
                <thead>
                <tr>
                    <th scope="col">
                        <input type="checkbox" v-model="selectAll"/>
                    </th>
                    <th scope="col" v-if="canViewAccounting">สร้างใบบิล</th>
                    <th scope="col">เลขใบจอง</th>
                    <th scope="col">วันที่สร้างใบจอง</th>
                    <th scope="col">เซลล์</th>
                    <th scope="col" style="min-width: 100px">รหัสลูกค้า</th>
                    <th scope="col" style="min-width: 150px">ชื่อลูกค้า</th>
                    <th scope="col">การขนส่ง</th>
                    <th scope="col">ค้างส่ง</th>
                    <th scope="col">สถานะ</th>
                    <th scope="col">วันที่อัพเดท</th>
                    <th scope="col">พิมพ์ใบจอง</th>
                    <th scope="col">พิมพ์ใบค้างส่ง</th>
                    <th scope="col">เปิด DO</th>
                    <th scope="col">แก้ไข
                        <template v-if="canViewAccounting"> / ลบ</template>
                    </th>
                </tr>
                </thead>
                <tbody>
                <template v-for="data in orderList">
                    <tr :class="{print : !data.status_print_order , transportation : (data.transport_type_id === 4 && !data.status_print_order),'font-weight-bold' : checkbox_id.includes(data.id)}">
                        <td>
                            <input type="checkbox" v-model="checkbox_id"
                                   :value="data.id"/>
                        </td>
                        <td v-if="canViewAccounting">
                            <template v-if="data.status_confirm">
                                <button @click="goToInvoiceForm(data.id)"
                                        type="button"
                                        :disabled="data.status.id===3 || tn_loading"
                                        class="btn btn-secondary">สร้างใบบิล
                                </button>
                            </template>
                            <template v-else>-</template>
                        </td>
                        <td>
                            <template v-if="data.order_id">
                                {{ data.order_id }}
                            </template>
                            <template v-else>
                                -
                            </template>
                        </td>
                        <td>{{ data.date | moment("DD/MM/YYYY") }}</td>
                        <td>
                            <template v-if="data.customer && data.customer.sale">
                                {{ data.customer.sale.name }}
                            </template>
                            <template v-else>-</template>
                        </td>
                        <td>
                            <template v-if="data.customer">{{ data.customer.customer_id }}</template>
                            <template v-else>-</template>
                        </td>
                        <td>
                            <template v-if="data.customer">
                                <template v-if="data.customer_other">
                                    {{ data.customer.store_name ? data.customer.store_name : data.customer.first_name }}
                                    /
                                    {{
                                        data.customer_other.store_name ? data.customer_other.store_name : data.customer_other.first_name
                                    }}
                                </template>
                                <template v-else>
                                    {{ data.customer.store_name ? data.customer.store_name : data.customer.first_name }}
                                </template>
                            </template>
                            <template v-else>-</template>
                        </td>
                        <td>
                            <template v-if="data.transport_type">{{ data.transport_type.name }}</template>
                            <template v-else>-</template>
                        </td>
                        <td>{{ data.remain_product | amount }}</td>
                        <td>
                            <template>
                                <span :class="{'text-primary': data.status.id === 2 ,
                                'text-success' :  data.status.id === 3 ,
                                'text-danger' :  data.status.id === 1}" style="font-weight: bold">
                                    {{ data.status.name }}
                                </span>
                            </template>
                        </td>
                        <td>{{ data.updated_at | moment("DD/MM/YYYY") }}</td>
                        <td>
                            <button type="button"
                                    @click="printOrder(data.id)"
                                    class="btn btn-primary">
                                <icon name="print"></icon>
                                พิมพ์ใบจอง
                            </button>
                        </td>
                        <td>
                            <button type="button"
                                    :disabled="data.order_status_id == 3"
                                    @click="printOrderOutStanding(data.id)"
                                    class="btn btn-primary">
                                <icon name="print"></icon>
                                พิมพ์ใบค้างส่ง
                            </button>
                        </td>
                        <td>
                            <button type="button"
                                    v-if="data.order_status_id == 2"
                                    @click="openNewDO(data.id)"
                                    class="btn btn-secondary">
                                เปิด DO ใหม่
                            </button>
                        </td>
                        <td>
                            <a @click="goToOrderForm(data.id)">
                                <icon name="pencil-alt"></icon>
                            </a>
                            &nbsp&nbsp
                            <template v-if="canViewSuperAdmin || (canSaleView && !data.order_id)">
                                <a @click="showDeleteModal(data.id)">
                                    <icon name="trash"></icon>
                                </a>
                                <br/>
                                <a v-if="data.status.id === 2" @click="showaddNote(data.id,data.note_2)">หมายเหตุ</a>
                            </template>
                        </td>
                    </tr>
                </template>
                </tbody>
            </table>
        </div>
        <div v-if="orderList.length > 0">
            <vue-pagination :pagination="dataPaginate"
                            @paginate="getOrderPage">
            </vue-pagination>
        </div>
        <br/>
        <!-- ---approve--- -->
        <b-modal hide-header hide-footer centered ref="approve">
            <!--<div><order-modal @submit="updateApprove"></order-modal></div>-->
        </b-modal>
        <!-- ---delete---- -->
        <b-modal hide-header hide-footer ref="delete_item">
            <div style="text-align: center;">
                <h4>คุณต้องการลบข้อมูลใช่ไหม?</h4>
                <br/>
                <button
                    type="button"
                    class="btn btn-success"
                    @click="deleteOrderList">ตกลง
                </button>
                &nbsp&nbsp
                <button
                    type="button"
                    class="btn btn-secondary"
                    @click="hideDeleteModal">ยกเลิก
                </button>
            </div>
        </b-modal>

        <!-- ---List Order---- -->
        <b-modal hide-header hide-footer ref="list_order">
            <div style="text-align: center;">
                <h4>พิมพ์รายงานค้างส่ง (ใบจอง)</h4>
                <br/>
                <div class="row form-group">
                    <label class="col-sm-5 text-right">เลือกเซลล์ที่ต้องการพิมพ์</label>
                    <div class="col-sm-6">
                        <multiselect
                            v-model="search_order.sale"
                            :options="sellers"
                            placeholder="ค้นหาเซลล์"
                            :customLabel="customSaleNameWithCode"
                            :show-labels="false"
                            track-by="id">
                        </multiselect>
                    </div>
                </div>
                <div class="row form-group">
                    <label class="col-sm-5 text-right">เลือกลูกค้าที่ต้องการพิมพ์</label>
                    <div class="col-sm-6">
                        <multiselect
                            v-model="search_order.customer"
                            :options="customers"
                            :customLabel="customerWithLabel"
                            placeholder="ค้นหาลูกค้า"
                            :show-labels="false"
                            track-by="id">
                        </multiselect>
                    </div>
                </div>
                <div class="row form-group">
                    <label class="col-sm-5 text-right">เลือกช่วงที่ต้องการพิมพ์</label>
                    <div class="col-sm-6">
                        <b-form-select :options="print_date"
                                       v-model="search_order.range">
                        </b-form-select>
                    </div>
                </div>
                <div class="row form-group" v-if="search_order.range == 1">
                    <label class="col-sm-5 text-right">พิมพ์รายงาน/วัน</label>
                    <div class="col-sm-5">
                        <date-picker v-model="search_order.date"
                                     :lang="lang"
                                     placeholder="วันที่ต้องการพิมพ์"
                                     format="DD/MM/YYYY" confirm>
                        </date-picker>
                    </div>
                </div>
                <div class="row form-group" v-if="search_order.range == 2">
                    <label class="col-sm-5 text-right">พิมพ์รายงาน/เดือน</label>
                    <div class="col-sm-5">
                        <date-picker v-model="search_order.month"
                                     type="month"
                                     :lang="lang"
                                     format="MM/YYYY"
                                     placeholder="เดือนที่ต้องการพิมพ์"
                                     confirm>
                        </date-picker>
                    </div>
                </div>
                <div class="row form-group" v-if="search_order.range == 3">
                    <label class="col-sm-5 text-right">พิมพ์รายงาน/ปี</label>
                    <div class="col-sm-5">
                        <date-picker v-model="search_order.year"
                                     type="year"
                                     lang="pt-br"
                                     placeholder="ปีที่ต้องการพิมพ์"
                                     format="YYYY"
                                     confirm>
                        </date-picker>
                    </div>
                </div>

                <button @click="printOrderList"
                        :disabled="search_order.range == null"
                        type="button"

                        class="btn btn-primary"
                >พิมพ์
                </button>
                &nbsp;&nbsp;
                <button
                    type="button"
                    class="btn btn-outline-secondary"
                    @click="hideModalListOrder">ยกเลิก
                </button>
            </div>
        </b-modal>
        <!---change order--->
        <b-modal hide-header hide-footer ref="change_status">
            <div style="text-align: center;">
                <h3>เปลี่ยนสถานะใบจอง</h3>
                <div class="row">
                    <div class="col-4 text-right"><label>สถานะใบจอง</label></div>
                    <div class="col-6">
                        <b-form-select :options="status_order_option"
                                       v-model="status_order_id">
                        </b-form-select>
                    </div>
                </div>
                <div class="col text-center mt-2">
                    <button
                        type="button"
                        class="btn btn-success"
                        @click="changeOrderStatus(status_order_id)">ตกลง
                    </button>
                    &nbsp&nbsp
                    <button
                        type="button"
                        class="btn btn-secondary"
                        @click="hideChangeOrderStatus">ยกเลิก
                    </button>
                </div>
            </div>
        </b-modal>
        <b-modal hide-header hide-footer ref="loading" no-close-on-backdrop no-close-on-esc>
            <loading :msg="msg" :status="status_loading" @submit="hideLoadingModal"></loading>
        </b-modal>
        <!--<pre class="alert alert-primary">{{ checkbox_id }}</pre>-->
        <!-- ------add Note------- -->
        <b-modal hide-header hide-footer ref="note_modal">
            <div style="text-align: center;">
                <h4>เพิ่มหมายเหตุ(เปิดบิลบางส่วน)</h4>
                <h5 v-if="this.note_selected">หมายเหตุ(เก่า)</h5>
                <textarea v-if="this.note_selected" style="width: 80%;resize: none;background-color:#cecece;"
                          v-model="note_selected" rows="4" readonly></textarea>
                <h5>หมายเหตุ(ใหม่)</h5>
                <textarea style="width: 80%;resize: none" v-model="note_message" rows="4"></textarea>
                <br/>
                <button :disabled="note_message.length == 0"
                        type="button"
                        class="btn btn-success"
                        @click="addNote">
                    ตกลง
                </button>
                &nbsp&nbsp
                <button
                    type="button"
                    class="btn btn-outline-secondary"
                    @click="hideaddNote">
                    ยกเลิก
                </button>
            </div>
        </b-modal>
    </div>
</template>

<script>
import {mapState} from "vuex";
import OrderModal from "./OrderModal";
import {domain} from "../../../util/Constants";
import VuePagination from "../../Pagination";
import DatePicker from 'vue2-datepicker'
import moment from "moment";
import Multiselect from "vue-multiselect";
import {
    canSaleOrdersAllView,
    canSaleOrdersUpdate,
    canSaleView,
    canViewAccounting,
    canViewSuperAdmin,
} from "../../../util/Permissions";
import Loading from "../../Utility/Loading";

export default {
    components: {
        Loading,
        VuePagination,
        OrderModal,
        DatePicker,
        Multiselect
    },
    name: "order-list",
    data() {
        return {
            msg: '',
            status_loading: '',
            tn_loading: false,
            id: "",
            orderList: [],
            customers: [],
            activeCloseDate: false,
            dateFormat: 'D/MM/YYYY',
            test: [],
            domain: "",
            event_submit: false,
            checkbox_id: [],
            select_all: false,
            currentDate: "",
            print_date: [
                {value: null, text: "ช่วง วัน - เดือน - ปี"},
                {value: 1, text: "เลือกพิมพ์วัน"},
                {value: 2, text: "เลือกพิมพ์เดือน"},
                {value: 3, text: "เลือกพิมพ์ปี"},
            ],
            status_order_option: [
                {value: 1, text: "รอเปิดใบบิล"},
                {value: 2, text: "เปิดใบบางส่วน"},
                {value: 3, text: "ปิดใบจอง"},
            ],
            status_order_id: null,
            changeFormat: {
                stringify: (date) => {
                    let date_moment = moment(date).format('YYYY');
                    const year = parseInt(date_moment) + 543;
                    return date ? moment(date).format('DD/MM/' + year) : null
                },
                parse: (value) => {
                    return value ? moment(value, 'DD/MM/YYYY').subtract(543, 'y').toDate() : null
                }
            },
            lang: {
                days: ['อา', 'จ', 'อ', 'พ', 'พฤ', 'ศ', 'ส'],
                months: ['มกราคม', 'กุมภาพันธ์', 'มีนาคม', 'เมษายน', 'พฤษภาคม', 'มิถุนายน', 'กรกฎาคม', 'สิงหาคม', 'กันยายน', 'ตุลาคม', 'พฤศจิกายน', 'ธันวาคม'],
                pickers: ['ถัดไป 7 วัน', 'ถัดไป 30 วัน', 'ก่อนหน้า 7 วัน', 'ก่อนหน้า 30 วัน'],
                placeholder: {
                    date: 'วว/ดด/ปปปป',
                }
            },
            dataPaginate: {
                current_page: 1,
                from: 1,
                last_page: 1,
                per_page: 1,
                total: 1,
                to: 1
            },
            note_message: '',
            note_id: '',
            note_selected: '',
        };
    },
    created() {
        localStorage.setItem('reloaded', 'false');
        this.domain = domain;
        this.getOrderPage();
        this.$store.dispatch("Common/setOrderStatus");
        this.$store.dispatch("TransportType/setTransportTypes");
        this.$store.dispatch("Seller/get");
        this.$store.dispatch("Order/clearSearch");
        this.$store.dispatch("Products/getProductAll");
        this.$store.dispatch('ProductType/get');
        this.getCustomerAll();
        this.getCurrentDate();
    },
    computed: {
        canSaleOrdersUpdate,
        canSaleView,
        canViewAccounting,
        canSaleOrdersAllView,
        canViewSuperAdmin,
        ...mapState({
            status: state => {
                return [
                    {
                        value: "",
                        text: "ค้นหาสถานะ"
                    },
                    ...state.Common.order_status.map(status => ({
                        value: status.id,
                        text: status.name
                    }))
                ];
            },
            transport: state => {
                return [
                    {
                        value: "",
                        text: "ค้นหาการขนส่ง"
                    },
                    ...state.TransportType.transportTypeList.map(trans => ({
                        value: trans.id,
                        text: trans.name
                    }))
                ];
            },
            optionProductType: state => {
                return [
                    {
                        value: "",
                        text: "หมวดหมู่สินค้า"
                    },
                    ...state.ProductType.data.map(type => ({
                        value: type.id,
                        text: type.name
                    }))
                ];
            },
            sellers: state => {
                return state.Seller.data;
            },
            search: state => {
                return state.Order.search;
            },
            search_order: state => {
                return state.Order.search_order;
            },
            user: state => {
                return state.Auth.user
            },
            status_create_invoice: state => {
                return state.Order.status_create_invoice
            },
            optionProducts: (state) => {
                return state.Products.product_all;
            },

        }),
        selectAll: {
            get: function () {
                return this.orderList ? this.checkbox_id.length >= this.orderList.length : false;
            },
            set: function (value) {
                if (value) {
                    this.select_all = true;
                    if (this.search.date.length > 0) {
                        if (this.search.date[0] && this.search.date[1]) {
                            this.search.date[0] = moment(this.search.date[0]).format("YYYY-MM-DD");
                            this.search.date[1] = moment(this.search.date[1]).format("YYYY-MM-DD");
                        } else {
                            this.search.date = [];
                        }
                    }
                    let data = {
                        order_id: this.search.order_id,
                        date: this.search.date,
                        status: this.search.status,
                        transport_type: this.search.transport_type,
                        sale_id: this.search.sale ? this.search.sale.id : '',
                        customer_id: this.search.customer ? this.search.customer.id : '',
                        action: 'select'
                    };
                    return this.$store.dispatch("Order/search", {
                        page: '',
                        search: data,
                    }).then(orders => {
                        if (orders.length > 0) {
                            orders.forEach(order => {
                                this.checkbox_id.push(order.id); //return id
                            })
                        }
                    })
                } else {
                    this.select_all = false;
                    this.checkbox_id = [];
                }
            }
        }
    },
    methods: {
        showaddNote(id, old_note) {
            this.note_id = id;
            this.note_selected = old_note ? old_note : '';
            this.note_message = '';
            this.$refs.note_modal.show();
        },
        hideaddNote() {
            this.$refs.note_modal.hide();
        },
        addNote() {
            let prepare_data = this.note_id.toString() + ',' + this.note_message;
            this.$store.dispatch("Order/addNote", prepare_data).then(() => {
                this.hideaddNote();
                this.getOrderPage();
            });
        },
        LabelSkuWithName(option) {
            if (this.optionProducts.length > 0) {
                return `${option.sku} - ${option.short_name}`
            }
        },
        customSaleNameWithCode(option) {
            return `${option.sale_id} - ${option.name}`
        },
        getCustomerAll() {
            // this.$store.dispatch("Customer/setAllCustomer").then(res=>{
            //     this.customers = res;
            // });
            this.$store.dispatch("Customer/setAllCustomerDropdown").then(res => {
                this.customers = res;
            });
        },
        printOrderList() {
            let start_date = '';
            let end_date = '';
            let customer_id = '';
            let sale_id = '';
            let transport_type_id = this.search.transport_type ? this.search.transport_type : '';
            let product_type_id = this.search.product_type_id ? this.search.product_type_id : '';
            let product_id = this.search.product ? this.search.product.id : '';
            if (this.search.date.length > 0 && this.search.date[0]) {
                start_date = moment(this.search.date[0]).format('YYYY-MM-DD');
                end_date = moment(this.search.date[1]).format('YYYY-MM-DD');
                if (this.search.customer) {
                    customer_id = this.search.customer.id;
                }
                if (this.canSaleOrdersAllView) {
                    if (this.search.sale) {
                        sale_id = this.search.sale.id;
                    }
                } else {
                    sale_id = this.user.id;
                }
                window.open(domain + "/order-report?start_date=" + start_date +
                    "&end_date=" + end_date +
                    "&customer_id=" + customer_id +
                    "&transport_type_id=" + transport_type_id +
                    "&product_type_id=" + product_type_id +
                    "&product_id=" + product_id +
                    "&sale_id=" + sale_id);
            } else {
                alert('กรุณาเลือกช่วงวันที่ที่ต้องการพิมพ์รายงานค้างส่ง')
            }
        },
        showModalListOrder() {
            this.$refs.list_order.show();
        },
        hideModalListOrder() {
            this.$refs.list_order.hide();
            this.$store.dispatch("Order/clearSearch")
        },
        showLoadingModal() {
            this.$refs.loading.show();
        },
        hideLoadingModal() {
            this.$refs.loading.hide();
        },
        showChangeOrderStatus() {
            this.$refs.change_status.show();
        },
        hideChangeOrderStatus() {
            this.$refs.change_status.hide();
        },
        customerWithLabel(option) {
            return `${option.customer_id} - ${option.store_name}`
        },
        showApproveModal(id) {
            this.$store.dispatch("Order/showOrder", id).then(() => {
                this.$refs.approve.show();
            });
        },
        goToOrderForm(id) {
            this.msg = 'กำลังดาวโหลดข้อมูล กรุณารอสักครู่';
            this.status_loading = 1;
            this.showLoadingModal();
            if (id !== null) {
                this.$store.dispatch("Order/showOrder", id).then(() => {
                    this.$router.push({
                        name: "order-form",
                        params: {id}
                    });
                    this.hideLoadingModal();
                });
            } else {
                this.$store.dispatch("Order/clearFormData").then(() => {
                    this.$router.push({
                        name: "order-form",
                        params: {id}
                    });
                    this.hideLoadingModal();
                });
            }
        },
        openNewDO(id) {
            this.msg = 'กำลังดาวโหลดข้อมูล กรุณารอสักครู่';
            this.status_loading = 1;
            this.showLoadingModal();
            this.$store.dispatch("Order/showOrderNewDO", id).then(() => {
                this.$router.push({
                    name: "order-form",
                    params: {id, newDO: 'yes'}
                });
                this.hideLoadingModal();
            });
        },
        deleteOrderList() {
            this.$store.dispatch("Order/delete", this.id).then(() => {
                this.hideDeleteModal();
                this.$store.dispatch("Order/setOrders");
                this.getOrderPage();
            });
        },
        showDeleteModal(id) {
            this.id = id;
            this.$refs.delete_item.show();
        },
        hideDeleteModal() {
            this.$refs.delete_item.hide();
        },
        searchOrderList(page = 1) {
            let sale = "";
            let customer = "";
            if (this.search.date.length > 0) {
                if (this.search.date[0] && this.search.date[1]) {
                    this.search.date[0] = moment(this.search.date[0]).format("YYYY-MM-DD");
                    this.search.date[1] = moment(this.search.date[1]).format("YYYY-MM-DD");
                } else {
                    this.search.date = [];
                }
            }
            if (this.search.sale) {
                sale = this.search.sale.id
            }
            if (this.search.customer) {
                customer = this.search.customer.id
            }
            let product_id = this.search.product ? this.search.product.id : '';
            let product_type_id = this.search.product_type_id ? this.search.product_type_id : '';
            let data = {
                order_id: this.search.order_id,
                date: this.search.date,
                status: this.search.status,
                transport_type: this.search.transport_type,
                sale_id: sale,
                customer_id: customer,
                action: 'search',
                product_id,
                product_type_id
            };
            this.event_submit = true;
            this.showLoadingModal();
            this.msg = 'กำลังค้นหาข้อมูล';
            this.status_loading = 1;
            this.$store.dispatch("Order/search", {
                page: page,
                search: data
            }).then(res => {
                this.orderList = res.data;
                this.dataPaginate = {
                    current_page: res.current_page,
                    from: res.from,
                    last_page: res.last_page,
                    per_page: res.per_page,
                    total: res.total,
                    to: res.to
                }
                this.hideLoadingModal();
            }).catch(err => {
                this.showLoadingModal();
                this.msg = 'ค้นหาไม่สำเร็จ';
                this.status_loading = 3;
            });
        },
        getOrderPage() {
            const page = this.dataPaginate.current_page;
            if (this.event_submit) {
                this.searchOrderList(page);
            } else {
                this.$store.dispatch("Order/setOrders", page).then(res => {
                    this.orderList = res.data;
                    this.dataPaginate = {
                        current_page: res.current_page,
                        from: res.from,
                        last_page: res.last_page,
                        per_page: res.per_page,
                        total: res.total,
                        to: res.to
                    }
                });
            }
        },
        updateApprove(value) {
            if (value == 'cancel') {
                this.$refs.approve.hide();
            } else {
                this.$store.dispatch("Order/save", value.id).then(() => {
                    this.$refs.approve.hide();
                    this.$store.dispatch("Order/setOrders");
                });
            }
            this.$store.dispatch("Order/setOrders");
        },
        goToInvoiceForm(id) {
            this.msg = 'กำลังดาวโหลดข้อมูลไปหน้าบิลขาย กรุณารอสักครู่';
            this.status_loading = 1;
            this.showLoadingModal();
            this.tn_loading = true;
            this.$store.dispatch("Invoice/clearFormData").then(() => {
                this.$store.dispatch("Order/showOrder", id).then(res => {
                    if (res[0] != false) {
                        //order product order to invoice
                        this.$store.dispatch("Order/createInvoiceFromOrder", id).then(() => {
                            if (this.status_create_invoice) {
                                this.$store.dispatch("Invoice/generateOrder");
                                let routeData = this.$router.resolve({
                                    name: 'invoice-form',
                                    params: {createFromOrder: true}
                                });
                                window.open(routeData.href, '_blank');
                                this.tn_loading = false;
                                this.hideLoadingModal();
                            } else {
                                this.msg = 'ใบจองนี้มีการเปิด TN ไปแล้ว / มีการปิดใบจองไปแล้ว';
                                this.status_loading = 3;
                                this.tn_loading = false;
                            }
                        }).catch(() => {
                            this.msg = 'ดาวโหลดข้อมูลไม่สำเร็จ กรุณาลองใหม่อีกครั้ง';
                            this.status_loading = 3;
                            this.tn_loading = false;
                        });
                    } else {
                        alert('ใบจองนี้หมดอายุแล้ว(ปิดโดยอัตโนมัติ)');
                        // this.msg = 'ใบจองนี้หมดอายุแล้ว(ปิดโดยอัตโนมัติ)';
                        // this.status_loading = 3;
                        // this.tn_loading = false;
                        window.location.reload();
                    }
                }).catch(err => {
                    this.msg = 'ดาวโหลดข้อมูลไม่สำเร็จ กรุณาลองใหม่อีกครั้ง';
                    this.status_loading = 3;
                    this.tn_loading = false;
                });
            });
        },
        printMultipleOrder() {
            let permission = false;
            if (this.canViewAccounting) {
                permission = true;
            }
            if (this.checkbox_id.length > 0) {
                let printData = this.checkbox_id.toString();
                window.open(domain + '/order-multi-pdf?permission=' + permission + '&name=' + this.user.name + '&id=' + printData,
                    '_blank');
                location.reload();
            }
        },
        printOrder(id) {
            let permission = false;
            if (this.canViewAccounting) {
                permission = true;
            }
            //console.log(this.user)
            window.open(domain + '/order-pdf/' + id + '?permission=' + permission + '&name=' + this.user.name,
                '_blank');
            location.reload();
        },
        printOrderOutStanding(id) {
            let permission = false;
            if (this.canViewAccounting) {
                permission = true;
            }
            window.open(domain + '/order-outstanding-pdf/?id=' + id + '&permission=' + permission,
                '_blank');
        },
        getCurrentDate() {
            this.currentDate = moment().format("YYYY-MM-DD");
        },
        changeOrderStatus(status) {
            if (this.checkbox_id.length > 0 && status) {
                let data = {
                    id: this.checkbox_id,
                    status: status,
                };
                this.$store.dispatch("Order/changeStatusOrder", data).then(() => {
                    alert("สำเร็จ");
                    this.checkbox_id = [];
                    this.getOrderPage();
                    this.hideChangeOrderStatus();
                }).catch(err => {
                    alert("ไม่สำเร็จ");
                });
            }
        }
    }
};
</script>

<style lang="scss" scoped>
.print {
    background-color: #A2D9CE;
}

.transportation {
    background-color: #F3DDB6;
}
</style>
